import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const PREVIOUS_PAGE_KEY = "eureka-previous-page";
const CURRENT_PAGE_KEY = "eureka-current-page";

export const NavigationTracker = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    const currentStoredPage = sessionStorage.getItem(CURRENT_PAGE_KEY);
    
    // If we have a stored current page and it's different from where we are now,
    // that means we navigated - so the stored page becomes the previous page
    if (currentStoredPage && currentStoredPage !== location.pathname) {
      sessionStorage.setItem(PREVIOUS_PAGE_KEY, currentStoredPage);
    }
    
    // Always update current page
    sessionStorage.setItem(CURRENT_PAGE_KEY, location.pathname);
    
    isFirstRender.current = false;
  }, [location.pathname]);

  return null;
};

export const getPreviousPage = (): string | null => {
  return sessionStorage.getItem(PREVIOUS_PAGE_KEY);
};
